export default __webpack_public_path__ + "static/media/ic-list-transactions.9c7b4e4c.svg";